// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mainLayout_wrapper__2a7AA","content":"mainLayout_content__cILkS"};